// Clerk appearance that hides its social buttons and the "or" divider, for pages
// that show GoogleLoginHintButton instead.
export const HIDE_CLERK_SOCIAL_BUTTONS = {
  socialButtonsRoot: 'hidden',
  dividerRow: 'hidden',
} as const;
